module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/beer@3x_185f13.jpg";